import { useDispatch, useSelector } from 'react-redux'
import { GET_STORE } from '@wellbeingxltd/fe-lib/constants'
import { formatDate } from '@wellbeingxltd/fe-lib/helpers'
import { getOverallWellbeingScoresRequest } from 'actions/profile'

const getWellbeingTableData = (data = []) => {
    const res = []
    data.forEach(item => {
        const newItem = {
            ...item,
            date: formatDate(item.date, { day: '2-digit', month: 'short', year: 'numeric', hour: 'numeric', minute: 'numeric' }),
        }
        if (newItem?.score) {
            res.push({ date: newItem.date, activity: `Wellbeing scores updated to ${newItem.score}/100` })
        }
        if (newItem?.transaction) {
            res.push({ date: newItem.date, activity: newItem.transaction })
        }
    })
    return res.reverse() // to show the most recent activity at the top
}

const uniqueDates = {}
const transactions = []
const TRANSACTION_Y = 10 // show all transactions on the same position that lower that min score (~25)

const normalizeDataForCharts = (data = []) => {
    const scores = data
        .map(item => ({ ...item, date: new Date(item.date).getTime() }))
        .map(item => (item?.transaction ? { ...item, transactionValue: TRANSACTION_Y } : item))

    scores.forEach(score => {
        const date = formatDate(score.date, { day: '2-digit', month: 'short', year: 'numeric' })
        if (score.transaction) {
            transactions.push(score)
        } else {
            if (uniqueDates[date]) {
                uniqueDates[date].push(score)
            } else {
                uniqueDates[date] = [score]
            }
        }
    })
    const averageScores = []
    for (const date in uniqueDates) {
        averageScores.push({
            date: new Date(uniqueDates[date][uniqueDates[date].length - 1].date),
            score: uniqueDates[date][uniqueDates[date].length - 1].score,
        })
    }

    return [...transactions, ...averageScores].sort((score1, score2) => score1.date - score2.date)
}

const getLastScore = (data = []) => {
    const scoreTab = data.filter(wellbeing => wellbeing?.transaction == null)
    return scoreTab[scoreTab.length - 1].score
}

export const useProfile = () => {
    const dispatch = useDispatch()
    const {
        appState: { overallWellbeingScoreError, overallWellbeingScoreLoading },
        database: {
            goals,
            overallWellbeingScore,
            sections,
            transactions,
            userProfile: {
                assessmentDate,
                assessmentState,
                assessmentUpdateState,
                totalBudget,
                newBudgetSetup,
                familyName,
                givenName,
                hasRewards,
                locale,
                pillars,
                pilotTag,
                userId,
            },
        },
    } = useSelector(GET_STORE.PROFILE)
    const {
        appState: { dashboardLoading, deleteGoalError, deleteGoalLoading, dashboardLoaded },
    } = useSelector(GET_STORE.HOME)

    const companyName = JSON.parse(localStorage.getItem('loginConfig')).companyName
    const clientId = JSON.parse(localStorage.getItem('userProfile'))?.clientId
    const email = JSON.parse(localStorage.getItem('userProfile'))?.email

    return {
        assessmentDate,
        assessmentState,
        assessmentUpdateState,
        budget: totalBudget,
        newBudgetSetup,
        companyName,
        clientId,
        dashboardLoading,
        deleteGoalError,
        deleteGoalLoading,
        dashboardLoaded,
        email,
        familyName,
        getOverallWellbeingScores: () => dispatch(getOverallWellbeingScoresRequest()),
        givenName,
        goals,
        hasRewards,
        locale,
        overallWellbeingScoreError,
        overallWellbeingScoreLoading,
        pillars,
        pilotTag,
        rewardsLimit: newBudgetSetup?.rewardsLimit,
        score: overallWellbeingScore?.length ? getLastScore(overallWellbeingScore) : 0,
        scoresAndTransactionsForChart: normalizeDataForCharts(overallWellbeingScore),
        sections,
        showBudget: newBudgetSetup?.showBudgetToUser === false && totalBudget === 0 ? false : true,
        transactions,
        userId,
        wellbeingTableData: getWellbeingTableData(overallWellbeingScore),
    }
}
